import { createFileRoute } from '@tanstack/react-router';

import { WorkloadPage } from '@/features/profiles/company-pages';

export const Route = createFileRoute('/_app/org/$orgId/workload')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <WorkloadPage orgId={orgId} />;
}
